import { useRequiredContext } from "@redotech/react-util/context";
import { RpcClientContext } from "@redotech/redo-customer-portal-shared/contexts/rpc";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orderReturnsQueryKey } from "./order-returns-query-key";

export function useUpdateReturnExchangeAddress(orderId?: string) {
  const rpcClient = useRequiredContext(RpcClientContext);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      input: Parameters<typeof rpcClient.updateReturnExchangeAddress>[0],
    ) => rpcClient.updateReturnExchangeAddress(input),
    onSuccess: (_, { returnId }) => {
      void queryClient.invalidateQueries({
        queryKey: ["returnConfirmation", returnId],
      });
      if (orderId) {
        void queryClient.invalidateQueries({
          queryKey: orderReturnsQueryKey(orderId),
        });
      }
    },
  });
}
